<div class="row">
  <div class="tw-w-full">
    <div class="card card-custom gutter-b">

      <ng-content select="app-page-header"></ng-content>
      <ng-content select="[custom-header]"> </ng-content>

      <div class="card card-body page-body tw-pt-5" [class.p-0]="noPadding" [class]="class">
        <ng-content select=".app-page-content"></ng-content>
      </div>

      <ng-content select="[special-loading]"></ng-content>

    </div>
  </div>
</div>
